import { Constant } from '@genial/config';
import { ColorTypes } from '@genial/design-tokens';

import { FilterModalTypes } from '../../../../../../../../components/FilterModal';
import { TableHeadItemRecurse } from '../../../../../../../../components/TableHead';
import { equityMarketStatusQuery } from '../../../../../../../../store/product/selectors';
import { OperationType } from '../../../../contexts/constants';
import { AssetCaptionType } from '../../../AssetCaptions';
import { AssetNoticesNormalized } from '../../../AssetNotices';
import {
  limitedOrderNotice,
  onlyHighRiskInvestorsNoticeEquity,
  warningOperatingCostsInvestorsNoticeEquity,
} from '../../../AssetNotices/constants';

import { EquitySellAsset } from '.';

export const equityTableHead: TableHeadItemRecurse[] = [
  { title: 'Produto', flex: 1.5 },
  { title: 'Último Preço' },
  { title: 'Melhor Compra' },
  { title: 'Melhor Venda' },
  { title: 'Fechamento' },
  { title: 'Quantidade', flex: 1.5 },
  { title: 'Preço por ativo', flex: 1.5 },
  { title: 'Total estimado' },
  { title: '' },
];

export const equitySellConstants = {
  id: 'equity',
  typeGetterId: 'equitySell',
  operationId: 2,
  operationName: 'Venda',
  operationType: 'sell' as OperationType,
  color: 'product.rendavariavelsale' as ColorTypes.Option,
  title: 'Renda Variável',
  principalComponent: EquitySellAsset,
  tableHead: equityTableHead,
  hideTableHead: true,
  marketStatusSelector: equityMarketStatusQuery,
  hasFilters: false,
  mountFilters: (): FilterModalTypes.FilterType[] => [],
  hasCategories: false,
  categoriesLabel: '',
  categoriesField: '',
  mountCategories: () => [],
  captions: [] as AssetCaptionType[],
  groupNotices: true,
  notices: [
    warningOperatingCostsInvestorsNoticeEquity,
    onlyHighRiskInvestorsNoticeEquity,
    limitedOrderNotice,
  ] as AssetNoticesNormalized[],
  hasRefresher: true,
  unleashFlag: Constant.UnleashEquitySellToggle,
  unleashFlagBatchTicket: Constant.UnleashBasketEquityToggle,
  unleashFlagCustomers: Constant.UnleashCustomersEquityToggle,
} as const;
